function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys1 = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys1 = ownKeys1.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys1.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import regeneratorRuntime from "regenerator-runtime";
import { computed, defineComponent, ref, reactive, toRefs, watch } from "vue";
import { definePropType } from "@types-vue/props";
import { v2Host } from "@/config/host";
import Uploader from "@/components/Uploader/index.vue";
import _ from "lodash";
import { Message, Loading } from "element-ui";
import Drawer from "../drawer/index.vue";
import regexp from "@com/utils/regexp.js";
import { productSave, productUpdate } from "@pt/api/advapp/index";
import { getAppInfo } from "@pt/api/common";
import { defaultInfo, appInfo } from "./index";
import i18n from "@/lang";
import { ProductType } from "@pt/enums/product";
import { beforeUpload, productNameValidator } from "./utils";
import WxgameForm from "./wxgame-form.vue";
export default defineComponent({
    props: {
        visible: {
            type: Boolean,
            default: true
        },
        action: {
            type: String,
            default: "create"
        },
        formItemInfo: {
            type: definePropType(Object),
            default: function() {
                return {};
            }
        },
        drawerLoading: {
            type: Boolean,
            default: false
        }
    },
    components: {
        Drawer: Drawer,
        Uploader: Uploader,
        WxgameForm: WxgameForm
    },
    setup: function setup(props, param) {
        var emit = param.emit;
        var clearCommonAppUrl = function clearCommonAppUrl() {
            commonAppUrl.ios = "";
            commonAppUrl.android = "";
        };
        var disabledRadio = function disabledRadio(platforms) {
            return props.action === "dMaker" && productForm.productForm.platforms !== platforms;
        };
        var formRef = ref();
        var productForm = reactive({
            productForm: _.cloneDeep(defaultInfo)
        });
        var uploadLoading = ref(false);
        var commonAppUrl = reactive({
            ios: "",
            android: ""
        });
        var handleClose = function(val) {
            var _$ref;
            (_$ref = formRef.value) === null || _$ref === void 0 ? void 0 : _$ref.resetFields();
            emit("update:visible", val);
            emit("initForm");
            productForm.productForm = _.cloneDeep(defaultInfo);
            clearCommonAppUrl();
        };
        var drawerVisible = computed({
            get: function() {
                return props.visible;
            },
            set: function(val) {
                handleClose(val);
            }
        });
        var contentLoading = computed({
            get: function() {
                return props.drawerLoading;
            },
            set: function(val) {
                emit("update:drawerLoading", val);
            }
        });
        var btnDisable = computed(function() {
            var isEmpty = true;
            if (productForm.productForm.platforms === "android,ios" && productForm.productForm.type === "app") {
                isEmpty = !!(productForm.productForm.app_info[0] && productForm.productForm.app_info[1] && productForm.productForm.app_info[0].app_url && productForm.productForm.app_info[1].app_url);
            } else if (productForm.productForm.type === ProductType.WXGame) {
                isEmpty = !!(productForm.productForm.app_info[0] && productForm.productForm.app_info[0].name);
            } else {
                isEmpty = !!(productForm.productForm.app_info[0] && productForm.productForm.app_info[0].app_url);
            }
            return !isEmpty;
        });
        var getDrawerTitle = computed(function() {
            if (props.action === "dMaker") {
                return i18n.t("playTurbo.commonTemplate.versionEditTitle");
            }
            return props.action === "create" ? i18n.t("playTurbo.recordProject.record.promotional.create") : i18n.t("playTurbo.promoteManagement.promote.edit.label");
        });
        watch(function() {
            return props.formItemInfo;
        }, function(val) {
            if (props.action === "update" || props.action === "dMaker") {
                productForm.productForm = _.cloneDeep(val);
                if (val.type === "website" && val.platforms === "android,ios") {
                    productForm.productForm.app_info = productForm.productForm.app_info.slice(0, 1);
                } else {
                    for(var i = 0; i < productForm.productForm.app_info.length; i++){
                        var item = productForm.productForm.app_info[i];
                        if (item.platform === "ios" || item.platform === "android") {
                            commonAppUrl[item.platform] = item.app_url;
                        }
                    }
                }
            }
        }, {
            immediate: true,
            deep: true
        });
        var urlValidator = function(rule, value, callback) {
            if (regexp.url.test(value)) {
                callback();
            } else {
                callback(new Error("".concat(i18n.t("playTurbo.promoteManagement.promote.table.error"))));
            }
        };
        var versionNameValidator = function(rule, value, callback) {
            var re = /^[0-9a-zA-Z_]{1,50}$/;
            if (re.test(value)) {
                callback();
            } else {
                callback(new Error("".concat(i18n.t("playTurbo.commonTemplate.creativeInfo.form.versionName.validateMessage"))));
            }
        };
        var uploadIconUrl = computed(function() {
            return "".concat(v2Host, "/advapp/product/upload-icon");
        });
        // 产品类型为website图标非必填
        var appIconRules = computed(function() {
            return productForm.productForm.type !== "website" ? {
                required: true,
                message: i18n.t("playTurbo.promoteManagement.promote.icon.rules"),
                trigger: "blur"
            } : {};
        });
        var productTypeOptions = [
            {
                label: "App",
                value: ProductType.APP
            },
            {
                label: "Website",
                value: ProductType.Website
            },
            {
                label: i18n.t("playTurbo.promoteManagement.promote.wxgame.title"),
                value: ProductType.WXGame
            }, 
        ];
        var successUpload = function(response, index) {
            if (response.code === 0) {
                productForm.productForm.app_info[index].app_icon = response.data.url;
            } else {
                Message.error(response.msg);
            }
        };
        // 产品类型为website只显示一个URL
        var changePlatform = function(type) {
            if (productForm.productForm.type === "website" && type === "android,ios") {
                productForm.productForm.app_info = _.cloneDeep(appInfo["ios"]);
            } else {
                productForm.productForm.app_info = _.cloneDeep(appInfo[type]);
            }
            clearCommonAppUrl();
        };
        var changeType = function(type) {
            var _$ref;
            productForm.productForm.type = type;
            changePlatform(productForm.productForm.platforms);
            if (productForm.productForm.type === "website" && productForm.productForm.platforms === "android,ios") {
                productForm.productForm.app_info = productForm.productForm.app_info.slice(0, 1);
            }
            if (productForm.productForm.type === "app" && productForm.productForm.platforms === "android,ios") {
                productForm.productForm.app_info = _.cloneDeep(appInfo["android,ios"]);
            }
            if (productForm.productForm.type === ProductType.WXGame) {
                productForm.productForm.app_info = _.cloneDeep(appInfo["wxgame"]);
            }
            (_$ref = formRef.value) === null || _$ref === void 0 ? void 0 : _$ref.clearValidate();
        };
        var getPlatformName = function(item) {
            if (productForm.productForm.type === "website") {
                return "URL";
            }
            return item.platform === "ios" ? "iOS URL" : "Android URL";
        };
        var getPlatformPlaceholder = function(item) {
            if (productForm.productForm.type === "website") {
                return i18n.t("playTurbo.recordProject.record.promotional.website.placeholder");
            }
            return item.platform === "ios" ? i18n.t("playTurbo.recordProject.record.promotional.ios.placeholder") : i18n.t("playTurbo.recordProject.record.promotional.android.placeholder");
        };
        var getNamePlaceholder = function(item) {
            if (productForm.productForm.type === "website") {
                return i18n.t("playTurbo.promoteManagement.promote.table.website.rules");
            }
            return item.platform === "ios" ? i18n.t("playTurbo.promoteManagement.promote.table.ios.rules") : i18n.t("playTurbo.promoteManagement.promote.table.android.rules");
        };
        var getDescPlaceholder = function(item) {
            if (productForm.productForm.type === "website") {
                return i18n.t("playTurbo.promoteManagement.promote.table.website.description");
            }
            return item.platform === "ios" ? i18n.t("playTurbo.promoteManagement.promote.table.ios.description") : i18n.t("playTurbo.promoteManagement.promote.table.android.description");
        };
        var getCommonApp = function() {
            var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(url, index, type) {
                var res, urlInfo;
                return regeneratorRuntime.wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            if (url) {
                                _ctx.next = 2;
                                break;
                            }
                            return _ctx.abrupt("return");
                        case 2:
                            if (!(commonAppUrl[type] === url)) {
                                _ctx.next = 4;
                                break;
                            }
                            return _ctx.abrupt("return");
                        case 4:
                            commonAppUrl[type] = url;
                            _ctx.prev = 5;
                            _ctx.next = 8;
                            return getAppInfo({
                                params: {
                                    app_url: url
                                }
                            });
                        case 8:
                            res = _ctx.sent;
                            urlInfo = res.data.data.info;
                            if (urlInfo && urlInfo.platform === type) {
                                productForm.productForm.app_info[index].in_system = 1;
                                productForm.productForm.app_info[index].app_icon = urlInfo.app_icon;
                                productForm.productForm.app_info[index].name = urlInfo.app_name;
                                productForm.productForm.app_info[index].package_name = urlInfo.package_name;
                            } else {
                                if (urlInfo && urlInfo.platform !== type) {
                                    Message.error("Invalid ".concat(type, " URL"));
                                }
                                productForm.productForm.app_info[index].in_system = 2;
                                productForm.productForm.app_info[index].app_icon = "";
                                productForm.productForm.app_info[index].name = "";
                                productForm.productForm.app_info[index].package_name = "";
                            }
                            productForm.productForm.app_info[index].desc = "";
                            _ctx.next = 17;
                            break;
                        case 14:
                            _ctx.prev = 14;
                            _ctx.t0 = _ctx["catch"](5);
                            console.log(_ctx.t0);
                        case 17:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        5,
                        14
                    ]
                ]);
            }));
            return function getCommonApp(url, index, type) {
                return _ref.apply(this, arguments);
            };
        }();
        var createProduct = function() {
            var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
                var submitLoading, androidInfo, _$param, res, res1;
                return regeneratorRuntime.wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            submitLoading = Loading.service({
                                lock: true,
                                background: "hsla(0,0%,100%,.9)"
                            });
                            if (productForm.productForm.type === "website" && productForm.productForm.platforms === "android,ios") {
                                androidInfo = Object.assign({}, productForm.productForm.app_info[0]);
                                androidInfo.platform = "android";
                                productForm.productForm.app_info.push(androidInfo);
                            }
                            if (productForm.productForm.type === ProductType.WXGame) {
                                productForm.productForm.platforms = "android,ios";
                            }
                            _$param = _objectSpread({}, productForm.productForm);
                            if (!(props.action === "dMaker")) {
                                _ctx.next = 7;
                                break;
                            }
                            emit("save-version-edit", _$param);
                            return _ctx.abrupt("return");
                        case 7:
                            if (!(props.action === "update")) {
                                _ctx.next = 22;
                                break;
                            }
                            _ctx.prev = 8;
                            _ctx.next = 11;
                            return productUpdate(_objectSpreadProps(_objectSpread({}, _$param), {
                                id: props.formItemInfo.id
                            }));
                        case 11:
                            res = _ctx.sent;
                            submitLoading.close();
                            if (res.data.code === 0) {
                                Message.success("".concat(i18n.t("playTurbo.whole.update.successful")));
                                handleClose(false);
                                emit("uploadTable");
                            }
                            _ctx.next = 20;
                            break;
                        case 16:
                            _ctx.prev = 16;
                            _ctx.t0 = _ctx["catch"](8);
                            submitLoading.close();
                            console.log(_ctx.t0);
                        case 20:
                            _ctx.next = 34;
                            break;
                        case 22:
                            _ctx.prev = 22;
                            _ctx.next = 25;
                            return productSave(_$param);
                        case 25:
                            res1 = _ctx.sent;
                            submitLoading.close();
                            if (res1.data.code === 0) {
                                Message.success("".concat(i18n.t("playTurbo.whole.create.successful")));
                                handleClose(false);
                                emit("uploadTable");
                                emit("toRecordProjectEdit", res1.data.data);
                            }
                            _ctx.next = 34;
                            break;
                        case 30:
                            _ctx.prev = 30;
                            _ctx.t1 = _ctx["catch"](22);
                            submitLoading.close();
                            console.log(_ctx.t1);
                        case 34:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        8,
                        16
                    ],
                    [
                        22,
                        30
                    ]
                ]);
            }));
            return function createProduct() {
                return _ref.apply(this, arguments);
            };
        }();
        var submitForm = function() {
            var _ref1 = _asyncToGenerator(regeneratorRuntime.mark(function _callee1() {
                var _$ref;
                return regeneratorRuntime.wrap(function _callee$(_ctx1) {
                    while(1)switch(_ctx1.prev = _ctx1.next){
                        case 0:
                            ;
                            if (formRef) {
                                _ctx1.next = 3;
                                break;
                            }
                            return _ctx1.abrupt("return");
                        case 3:
                            _ctx1.next = 5;
                            return (_$ref = formRef.value) === null || _$ref === void 0 ? void 0 : _$ref.validate(function() {
                                var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(valid) {
                                    return regeneratorRuntime.wrap(function _callee$(_ctx) {
                                        while(1)switch(_ctx.prev = _ctx.next){
                                            case 0:
                                                if (valid) {
                                                    createProduct();
                                                }
                                            case 1:
                                            case "end":
                                                return _ctx.stop();
                                        }
                                    }, _callee);
                                }));
                                return function(valid) {
                                    return _ref.apply(this, arguments);
                                };
                            }());
                        case 5:
                        case "end":
                            return _ctx1.stop();
                    }
                }, _callee1);
            }));
            return function submitForm() {
                return _ref1.apply(this, arguments);
            };
        }();
        return _objectSpreadProps(_objectSpread({
            formRef: formRef,
            getDrawerTitle: getDrawerTitle
        }, toRefs(productForm)), {
            uploadLoading: uploadLoading,
            drawerVisible: drawerVisible,
            uploadIconUrl: uploadIconUrl,
            appIconRules: appIconRules,
            btnDisable: btnDisable,
            contentLoading: contentLoading,
            productTypeOptions: productTypeOptions,
            ProductType: ProductType,
            versionNameValidator: versionNameValidator,
            productNameValidator: productNameValidator,
            urlValidator: urlValidator,
            handleClose: handleClose,
            getCommonApp: getCommonApp,
            beforeUpload: beforeUpload,
            successUpload: successUpload,
            submitForm: submitForm,
            changeType: changeType,
            getPlatformName: getPlatformName,
            getPlatformPlaceholder: getPlatformPlaceholder,
            getDescPlaceholder: getDescPlaceholder,
            getNamePlaceholder: getNamePlaceholder,
            changePlatform: changePlatform,
            disabledRadio: disabledRadio
        });
    }
});
